"use client";

import React, { useEffect } from "react";
import { QREditorContextProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { FrameDesignContent } from "../FrameDesignContent/FrameDesignContent";
import { FramesTabsProps } from "./types";
import "./styles.scss";
import { getFrameSectionClass, handleFrameSelectedSection } from "@/utils/framesHelper";

export const FramesTabs = ({ tabsData }: FramesTabsProps) => {
  const [indexSelected, setIndexSelected] = React.useState(0);
  const { qrData } = React.useContext<QREditorContextProps<any>>(QREditorContext);

  useEffect(() => {
    /*prevent that if "all" is selected, it will not change the selected tab*/
    if (Number(indexSelected) === tabsData.length) return;

    const isFrameSelected = handleFrameSelectedSection(tabsData, qrData, "frame-div-toggle");
    isFrameSelected && setIndexSelected(isFrameSelected.id - 1);
  }, [qrData.qrStyle.frameStyle]);

  const handleClick = (index: number, id: number) => {
    getFrameSectionClass("frame-div-toggle", id);
    setIndexSelected(index);
  };

  return (
    <div id="frames-tabs">
      <div className="frames-tabs-container">
        {tabsData.map((tab, i) => (
          <div
            key={i}
            onClick={() => handleClick(i, tab.id)}
            id={tab.id.toString()}
            className={`frames-tab ${i === indexSelected ? "active" : ""} ${tab.style ? "frames-tab--rounded" : ""}`}
          >
            {tab.label} {tab.subLabel && <span className="tab-subLabel">{tab.subLabel}</span>}
          </div>
        ))}
      </div>
      <FrameDesignContent
        content={tabsData}
        className={"frame-div-toggle"}
      />
    </div>
  );
};
